// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"245":"component---src-pages-index-tsx","453":"component---src-pages-404-tsx"}[chunkId] || chunkId) + "-" + {"108":"f2cbf65c1b5b060c5ae2","245":"5cd881ffffb9664e57c8","452":"377a50624ef935765c0e","453":"04c488e2ee501301d798"}[chunkId] + ".js";
};